import React from 'react';

import values  from '../../../../values';
import Context from '../../../../context';

import { useTranslation } from 'react-i18next';
import { BreadCrumb, CustomView, Pagination, ResponsiveView, TableHeader, TableLoading } from '../../../../components';

import ProvinceComponents from './Components';

import './index.sass';

type Props = {
  rqData: any;
};

const ProvinceScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestProvince, setRequestProvince } = React.useContext(Context.Location.Province);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id='location-province-screen-wrapper'>
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          <ProvinceComponents.Search />
          <ProvinceComponents.Create />
        </CustomView.Column>
      </CustomView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.LOCATION_PROVINCE_TABLE.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<ProvinceComponents.Body data={props.rqData} />)}
          </table>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === 'success' &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={Number(requestProvince?.page)}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestProvince!({
                  ...requestProvince,
                  page: page,
                })
              }
            />
          </div>
        )
      }
      <ProvinceComponents.Update />
      <ProvinceComponents.Delete />
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default ProvinceScreen;
